import { PageUrl } from '../PageUrl';

export const BLOG_CATEGORY = {
  INTRODUCTION: 'introduction',
  PLAY_TOOLS: 'play-tools',
  PARENTING: 'parenting',
  NURSERY: 'nursery',
  NEWS: 'news',
} as const;
export type BlogCategory = (typeof BLOG_CATEGORY)[keyof typeof BLOG_CATEGORY];

export const BLOG_CATEGORY_LABELS: Record<BlogCategory, string> = {
  introduction: '入門・基礎知識',
  'play-tools': '遊び・教具',
  parenting: '育児の悩み',
  nursery: '保育園・入園',
  news: 'お知らせ',
};

export type BlogMetaData = {
  title: string;
  description: string;
  thumbnailUrl: string;
  filePath: string;
  category: BlogCategory;
};

export const buildBlogFilePath = (slug: string) => `${PageUrl.BLOG_ROOT}${slug}/`;
